export default {
  data: () => {
    return {
      // 图表实例
      chart: null,
      // 图表配置
      option: {},
      total: 368
    };
  },
  // 模板编译完成
  mounted() {
    // 初始化图表
    this.fun_InitCharts();
  },
  // 模板销毁之前
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    // 销毁图表实例
    this.chart.dispose();
    // 清空图表实例
    this.chart = null;
  },
  // 自定义方法
  methods: {
    /**
     * 水球图
     * @author 滕威
     */
    fun_InitCharts() {
      // 绑定到实例
      let el = this.$el;
      // 延迟执行方法
      this.$nextTick(() => {
        // 初始化
        this.chart = this.$echarts.init(el);
        // 获取配置
        let option = this.fun_GetOption();
        option.title.subtext = this.total;
        // 设置图表配置
        this.chart.setOption(option);
      });
      // 监听图表，防止溢出父元素
      window.addEventListener("resize", () => {
        this.chart.resize();
      });
    },

    /**
     * @description 配置
     * @author 滕威
     */
    fun_GetOption() {
      return {
        title: {
          top: "42%",
          left: "center",
          text: "项目总数",
          subtext: "0",
          padding: 0,
          itemGap: 5,
          textStyle: {
            color: "#333333",
            fontWeight: "normal",
            fontFamily: "Microsoft YaHei",
            fontSize: 14
          },
          subtextStyle: {
            color: "#333333",
            fontWeight: "bold",
            fontFamily: "Microsoft YaHei",
            fontSize: 22
          }
        },
        tooltip: {
          trigger: "item"
        },
        series: [
          {
            type: "pie",
            radius: ["40%", "68%"],
            center: ["50%", "50%"],
            selectedMode: false,
            tooltip: {
              trigger: "item",
              borderWidth: 0,
              backgroundColor: "rgba(0, 0, 0, .6)",
              formatter: val => {
                return `<span>${val.marker}<span style="color: #FFFFFF;">${val.name}：</span><span style="color: #FFFFFF;">${val.value}</span></span>`;
              }
            },
            label: {
              color: "#666666"
              // normal: {
              //   show: true,
              //   position: "center",
              //   color: "#9A9EBA",
              //   formatter: `{a|项目总数}\n{b|${this.total}}`,
              //   rich: {
              //     a: {
              //       color: "#333333",
              //       lineHeight: 22,
              //       fontSize: 14
              //     },
              //     b: {
              //       color: "#333333",
              //       fontWeight: "bold",
              //       fontSize: 22
              //     }
              //   }
              // },
              // emphasis: {
              //   show: true
              // }
            },
            data: [
              {
                value: 50,
                name: "邀请招标",
                itemStyle: {
                  color: "#1FD5D5"
                }
              },
              {
                value: 40,
                name: "询价",
                itemStyle: {
                  color: "#9FE820"
                }
              },
              {
                value: 50,
                name: "竞争性磋商",
                itemStyle: {
                  color: "#3AA1FF"
                }
              },
              {
                value: 40,
                name: "竞争性磋商",
                itemStyle: {
                  color: "#BC90F6"
                }
              },
              {
                value: 40,
                name: "单一来源",
                itemStyle: {
                  color: "#F38EC1"
                }
              },
              {
                value: 60,
                name: "公开招标",
                itemStyle: {
                  color: "#FBD437"
                }
              },
              {
                value: 10,
                name: "框架协议",
                itemStyle: {
                  color: "#44CB6C"
                }
              }
            ]
          }
        ]
      };
    }
  }
};
